module.exports = __webpack_public_path__ + "img/q_icon.ee819287.png";